
import { useState } from 'react';
import Sidebar from './components/Sidebar';
import OverviewSection from './components/OverviewSection';
import HeroSection from './components/HeroSection';
import StoriesSection from './components/StoriesSection';
import TestimonialsSection from './components/TestimonialsSection';
import TeamSection from './components/TeamSection';
import StatisticsSection from './components/StatisticsSection';
import VolunteerOpportunitiesSection from './components/VolunteerOpportunitiesSection';
import PagesSection from './components/PageSection';
import AboutUsSection from './components/AboutUsSection';
import ContactInfo from './components/ContactInfo';
import DonationDashboard from './components/DonationDashboard';
import VolunteerDashboard from './components/VolunteerDashboard';
import ContactDashboard from './components/ContactDashboard';
import SiteSettingsSection from './components/SiteSettingsSection';

export default function DashboardPage() {
  const [activeSection, setActiveSection] = useState('overview');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const renderSection = () => {
    switch (activeSection) {
      case 'overview':
        return <OverviewSection onNavigate={setActiveSection} />;
      case 'site-settings':
        return <SiteSettingsSection />;
      case 'about':
        return <AboutUsSection />;
      case 'contact-info':
        return <ContactInfo />;
      case 'hero':
        return <HeroSection />;
      case 'stories':
        return <StoriesSection />;
      case 'testimonials':
        return <TestimonialsSection />;
      case 'donation':
        return <DonationDashboard />;
      case 'volunteer-application':
        return <VolunteerDashboard />;
      case 'contact-message':
        return <ContactDashboard />;
      case 'team':
        return <TeamSection />;
      case 'statistics':
        return <StatisticsSection />;
      case 'volunteer':
        return <VolunteerOpportunitiesSection />;
      case 'pages':
        return <PagesSection />;
      default:
        return <OverviewSection onNavigate={setActiveSection} />;
    }
  };

  const getSectionTitle = () => {
    const titles = {
      'overview': 'Overview',
      'site-settings': 'Site Settings',
      'hero': 'Hero Section',
      'stories': 'Impact Stories',
      'testimonials': 'Testimonials',
      'team': 'Team Members',
      'statistics': 'Statistics',
      'volunteer': 'Volunteer Opportunities',
      'pages': 'Pages',
    };
    return titles[activeSection] || 'Dashboard';
  };

  return (
    <div className="min-h-screen bg-[#f8f7fc]">
      <Sidebar 
        activeSection={activeSection} 
        onSectionChange={setActiveSection}
        isMobileOpen={isMobileMenuOpen}
        onMobileClose={() => setIsMobileMenuOpen(false)}
      />
      
      {/* Main Content */}
      <div className="lg:ml-64">
        {/* Top Header */}
        <header className="bg-white border-b border-gray-200 sticky top-0 z-30">
          <div className="flex items-center justify-between px-4 sm:px-6 lg:px-8 h-16">
            <div className="flex items-center gap-4">
              <button
                onClick={() => setIsMobileMenuOpen(true)}
                className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-600 hover:bg-gray-100 rounded-lg cursor-pointer"
              >
                <i className="ri-menu-line text-xl"></i>
              </button>
              <div>
                <h1 className="font-semibold text-gray-900">{getSectionTitle()}</h1>
                <p className="text-xs text-gray-500 hidden sm:block">Hope Restored Content Management</p>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <a
                href="/"
                target="_blank"
                className="hidden sm:flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-external-link-line"></i>
                View Site
              </a>
              <div className="w-10 h-10 bg-[#6a4bc3] rounded-full flex items-center justify-center text-white font-semibold">
                A
              </div>
            </div>
          </div>
        </header>

        {/* Content Area */}
        <main className="p-4 sm:p-6 lg:p-8">
          {renderSection()}
        </main>
      </div>
    </div>
  );
}
